import React from 'react';
import Box from '@mui/material/Box';
import { Button } from '../Buttons/Button';
import { Typography } from '../Typography';
interface SearchFiltersProps {
  t: (key: string) => string;
  filterCount?: number;
  onClearAllClick: () => void;
  children?: React.ReactNode;
  filterDescriptionKey?: string;
}
const SearchFilters: React.FC<React.PropsWithChildren<SearchFiltersProps>> = ({
  t,
  filterCount,
  onClearAllClick,
  children,
  filterDescriptionKey,
}: SearchFiltersProps) => {
  return (
    <>
      <Box display="flex" alignItems="baseline" justifyContent="space-between" data-testid="filter-list" mb="20px">
        <Box>
          <Typography variant="h3" component="h2" sx={{ fontSize: '18px', lineHeight: '28px', color: '#181D27' }}>
            {t('common:list_page:filters:title')}
          </Typography>
          {filterDescriptionKey && (
            <Typography variant="body2" component="p" sx={{ lineHeight: '20px', color: '#535862' }}>
              {t(filterDescriptionKey)}
            </Typography>
          )}
        </Box>
        <Button
          variant="text"
          color="primary"
          onClick={onClearAllClick}
          sx={{ textTransform: 'none', fontSize: '14px', fontWeight: 600, lineHeight: '20px', p: 0, minWidth: 'auto' }}
          disabled={!filterCount}
        >
          {t('ns.task_filter:clear_all_button')}
        </Button>
      </Box>

      {children}
    </>
  );
};
export { SearchFilters };
export * from './FilterSectionWrapper';
